'use strict';
'use es6';

var _hasRequiredFeatures = require('./utils/hasRequiredFeatures');

/*
 * Check required features before evaluating the rest of the application bundle.
 * This will prevent the app from throwing an exception when a required feature is missing (eg: WeakMap).
 */
if ((0, _hasRequiredFeatures.hasRequiredFeatures)(window)) {
  require('conversations-visitor-ui/Application');
}